/**
 * What the malware scan of a document's file has said (#414). The server sends it by name.
 *
 * Only `Clean` can be downloaded. A file is scanned after it is stored, so a document uploaded a
 * moment ago is `Pending` until the scan clears. A file stored before scanning existed reads `Clean`.
 *
 * The same four values as a chat attachment's `FileScanStatus`, which the messaging center keeps
 * for its own payloads.
 */
export enum DocumentFileScanStatus {
  Pending = "Pending",
  Clean = "Clean",
  Infected = "Infected",
  Failed = "Failed",
}
